import { useState, useEffect } from 'react';
import { CaseType } from '@/views/cases/data/schema';
import { cabinet_case_type, refreshCabinetCaseTypes } from '@/i18n';


export const useCaseTypes = () => {
  const [caseTypes, setCaseTypes] = useState<CaseType[]>(cabinet_case_type);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [initialized, setInitialized] = useState(false);

  // Auto-fetch case types if cache is empty on first load
  useEffect(() => {
    const initializeCaseTypes = async () => {
      if (!initialized && (!cabinet_case_type || cabinet_case_type.length === 0)) {
        setIsLoading(true);
        setError(null);
        try {
          await refreshCabinetCaseTypes();
          setCaseTypes([...cabinet_case_type]);
        } catch (err) {
          setError(err instanceof Error ? err.message : 'Failed to load case types');
        } finally {
          setIsLoading(false);
        }
      } else {
        setCaseTypes([...cabinet_case_type]);
      }
      setInitialized(true);
    };

    initializeCaseTypes();
  }, [initialized]);

  // Update local state when global cabinet_case_type changes
  useEffect(() => {
    if (initialized) {
      setCaseTypes([...cabinet_case_type]);
    }
  }, [cabinet_case_type, initialized]);

  const refreshCaseTypes = async () => {
    setIsLoading(true);
    setError(null);
    try {
      await refreshCabinetCaseTypes();
      setCaseTypes([...cabinet_case_type]);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to refresh case types');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    caseTypes,
    isLoading,
    error,
    refreshCaseTypes,
  };
};